import styled from "styled-components";
import { Icon, ButtonSettings } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";

export const IconStyled = styled(Icon)`
  width: ${props => props.iconWidth || props.theme.components.selector.icon.size};
  height: ${props => props.iconHeight || props.theme.components.selector.icon.size};
  fill: ${props => props.theme.color.white};
  margin-right: 0.3rem;
`;

export const PageWrapper = styled.div`
  padding-${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "right" : "left")}: 6.579rem; 
  padding-top: 4.211rem;
`;

export const LogoStyled = styled.div`
  position: absolute;
  ${props => `${props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? "left" : "right"}:4.6rem`};
`;

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 48.316rem;
  width: 81rem;
`;

export const MainHeading = styled.h3`
  color: ${props => props.theme.color.white};
  font-size: ${props => props.theme.font.size[props.fontSize]};
  font-weight: ${props => props.theme.font.weight.semiBold};
  margin-bottom: 1rem;
`;

export const HeadingText = styled.p`
  color: ${props => props.theme.color.greyLight};
  font-size: ${props => props.theme.font.size[props.fontSize]};
`;

export const HeadingWrapper = styled.div``;

export const MainViewWrapper = styled.div``;

export const MainViewContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ListItemWrapper = styled.ul`
  text-align: ${props => (props.theme.locale.dir === "rtl" ? "right" : "left")};
  width: 50rem;
`;

export const ProfileImageWrapper = styled.div`
  text-align: center;
`;
export const ProfileName = styled.div`
  color: ${props => props.theme.color.greyLight};
  font-size: ${props => props.theme.font.size.medium};
  font-weight: ${props => props.theme.font.weight.semiBold};
  line-height: 2.3rem;
  margin-top: ${props => props.theme.spacing.small};
`;

export const IndicatorWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1.6rem;

  p {
    color: ${props => props.theme.color.white};
    font-size: ${props => props.theme.font.size.xsmall};
    line-height: 1.125rem;
  }
`;

export const ButtonsWrapper = styled.div`
  ${props =>
    props.direction === "rtl" &&
    `margin-left:30rem;
          direction:ltr;
         `};
`;

export const ButtonStyled = styled(ButtonSettings)`
  width: 23.5rem;
  border-radius: 8px;
  background-color: ${props => props.theme.color.secondary};
  margin: 0 ${props => (props.theme.locale.dir === i18n.directions.LEFT_TO_RIGHT ? props.theme.spacing.small : 0)} 0
    ${props => (props.theme.locale.dir === i18n.directions.RIGHT_TO_LEFT ? props.theme.spacing.small : 0)};
  box-sizing: border-box;
  height: 66px;
`;

export const CheckboxStyled = styled.input`
  &[type="checkbox"] {
    height: ${props => props.height};
    width: ${props => props.width};
    visibility: hidden;

    cursor: pointer;
    position: relative;

    height: ${props => props.height};
    width: ${props => props.width};

    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;

      border: 4px solid ${props => props.theme.color.offWhite};
      border-radius: 4px;
      background-color: transparent;
      visibility: visible;
    }
    &.focused:before {
      border: 4px solid ${props => props.theme.color[props.focussedBorder]} !important;
      background-color: ${props => !props.borderUnset && props.theme.color.primary};
    }
    &:checked:before {
      border: unset;
      background-color: ${props => props.theme.color.white};
      background-image: url(/images/icons/white-checkbox.png);
      background-size: cover;
      backgrpund-repeat: no-repeat;
      visibility: visible;
    }
    &.focused:checked:before {
      border: unset !important;
      background-color: ${props => props.theme.color.black};
      background-image: url(/images/icons/Check-Icon-black.png) !important;
      background-size: cover;
      backgrpund-repeat: no-repeat;
    }
  }
`;

export const ProfileImageContainer = styled.div`
  height: 20rem;
  width: 20rem;
  border-radius: 50%;
`;

export const ProfileImage = styled.img`
  height: 100%;
  width: 100%;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.24);
  border-radius: 50%;
`;
